import {message} from 'antd';
import ObjectType from '@/types/ObjectType';
export enum checkListEnum {mobile,  code, password,}
export const mobileRule = /^[1][0-9]{10}$/
export const codeRule = /^[0-9]{4}$/
export const passwordRule = /^[A-Za-z0-9]{6,20}$/
export const oldPasswordRule =/^(?! )(?=.*?[0-9])(?=.*?[A-Z])(?=.*?[a-z])[A-Za-z0-9]{8,20}(?! )$/;
export const nameRule = /^[A-Za-z0-9\u4e00-\u9fa5]+$/
export const errorMessage: ObjectType = {
    mobile: '请输入正确手机号',
    code: '验证码输入有误',
    password: '密码输入有误'
}
export function *createCheckIterator(checkList: checkListEnum[], info: any) {
  
    let state = true
  
    const checkObject: Function[]= [checkMobile, checkVcode, checkPassword,]
  
    for (let i = 0; i < checkList.length; i++) {
        state = checkObject[checkList[i]](info[checkListEnum[i]]);
        yield state
    }
}

export function run(generator: any, checkList: checkListEnum[]) {
    let result = generator.next()
    for (let i = 0; i < checkList.length; i++) {
        if (result.done) return result
        if (!result.value) {
            message.error(errorMessage[checkListEnum[i]])
            return result
        }
        result = generator.next()
    }
    return result;
}

// 手机号
export function checkMobile (mobile: string) {
    return mobileRule.test(mobile)
}

// 密码
export function checkPassword (password: string) {
    return passwordRule.test(password)
}

// 验证码
export function checkVcode (vcode: string) {
    return codeRule.test(vcode)
}
